/**
 * Members Service Hooks
 * React hooks for accessing member management services
 */
import { useCCMS } from '../useCCMS';
/**
 * Hook to access all member-related services
 * @returns MemberServices object containing all member service instances
 */
export function useMembersServices() {
    const { services } = useCCMS();
    if (!services?.members) {
        throw new Error('Member services not available. Ensure CCMSProvider is configured with member services.');
    }
    return services.members;
}
/**
 * Hook to access MemberService
 */
export function useMemberService() {
    return useMembersServices().member;
}
/**
 * Hook to access FamilyService
 */
export function useFamilyService() {
    return useMembersServices().family;
}
/**
 * Hook to access MemberTypeService
 */
export function useMemberTypeService() {
    return useMembersServices().memberType;
}
/**
 * Hook to access MaritalStatusService
 */
export function useMaritalStatusService() {
    return useMembersServices().maritalStatus;
}
/**
 * Hook to access MemberAddressService
 */
export function useMemberAddressService() {
    return useMembersServices().memberAddress;
}
/**
 * Hook to access MemberLocationService
 */
export function useMemberLocationService() {
    return useMembersServices().memberLocation;
}
/**
 * Hook to access AllergyService
 */
export function useAllergyService() {
    return useMembersServices().allergy;
}
/**
 * Hook to access DisabilityService
 */
export function useDisabilityService() {
    return useMembersServices().disability;
}
/**
 * Hook to access RelationshipService
 */
export function useRelationshipService() {
    return useMembersServices().relationship;
}
/**
 * Hook to access MemberMeService — the authenticated user's own
 * member record (self-service "me" endpoints).
 */
export function useMemberMeService() {
    return useMembersServices().memberMe;
}
/**
 * Hook to access MemberCustomFieldService: member custom field definitions
 * (api/member-custom-fields; defining needs Admin or Member.CustomFields.Manage).
 */
export function useMemberCustomFieldService() {
    return useMembersServices().memberCustomField;
}
//# sourceMappingURL=useMembersServices.js.map